import { render, staticRenderFns } from "./analyze.vue?vue&type=template&id=71c90bae&scoped=true&"
import script from "./analyze.vue?vue&type=script&lang=js&"
export * from "./analyze.vue?vue&type=script&lang=js&"
import style0 from "./analyze.vue?vue&type=style&index=0&id=71c90bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c90bae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VIcon,VTextField})
